export enum locale {
  MESSAGE_DOWNLOAD_FAILED = '下載失敗',
  ALERT_NOT_PERMISSION = '沒有權限',
  MENU_PERMISSION_MANAGEMENT = '權限管理',
  DATA_CENTER = '數據中心',
  OPERATE_PERFORMANCE = '營運表現',
  CREATE_MERCHANT_BATCH = '批次新增店家',
}
